import { DataBean } from "../DataBean";

export class PayrollAccountant extends DataBean {


    public async updatePayrollBudgetAccountant(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "employees.PayrollFactor_updatePayrollBudgetAccountant_employees.PayrollFactor", [

            {
                "DataBeanProperties": id,
                "DataBeanName": "employees.PayrollFactor"
              }
        ]);
    }
}